<template>
  <div class="d-flex flex-column">
    <p>Vorlage auswählen</p>
    <!-- use slick for templates -->
    <slick ref="slick" :options="slickOptions">
      <a @click="changeTemplate(ImageTemplate)" v-for="(ImageTemplate,index) in getTemplateItems" :key="index" style="height: 100px; ">
        <img :src="$store.getters.getWebServerBaseUrl + ImageTemplate.image" height="100px" @click="clickImage(ImageTemplate)" :alt="setTitle">
      </a>
    </slick>
   
    <!-- NOT USED ANYMORE -->
    <div v-if="false">
      <b-dropdown offset="25" size="200"
        variant="outline-dark text-center"
        :text="setTitle"
        class="mt-2">

        <b-dropdown-item-button active-class="text-danger" v-for="(ImageTemplate,index) in getTemplateItems" :key="index" @click="changeTemplate(ImageTemplate)">
          {{ImageTemplate.title}}
        </b-dropdown-item-button>
      </b-dropdown>
    </div>
    
  </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default {
  name: "ShopVoucherTemplateSelector",
  components: { Slick },
  props: ["VoucherTemplatesData", "getSelectedItem"],
  data() {
    return {
      slide: 0,
      slickOptions: {
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    };
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getTemplateItems: function() {
      return this.VoucherTemplatesData.shopItem.imageTemplates;
    },
    setTitle: function(){
      if(this.getSelectedItem.selectedTemplate != undefined){
        return this.getSelectedItem.selectedTemplate.title;
      }else{
        return 'Motiv wählen'; // FIXME: multilanguage
      }
    } 
  },
  methods: {
    changeTemplate: function(ImageTemplate) {
      //console.log('Click on template:', ImageTemplate);
      
      this.getSelectedItem.selectedTemplate = ImageTemplate;
    },
    clickImage(/* ImageTemplate */){
      //console.log('Clicked!', ImageTemplate);
      
    },
    next() {
            this.$refs.slick.next();
    },
    prev() {
        this.$refs.slick.prev();
    },
    reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
            this.$refs.slick.reSlick();
        });
    },
  },
  mounted() {
    this.reInit();
  }
};
</script>
